import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=92d4ea94"
var script = {}


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports